module.exports = __webpack_public_path__ + "static/media/cameraimage.7fad8897.gif";